import React from 'react';

import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker
} from '@material-ui/pickers';

const TimePicker = (props) => {
    props = { ...defaultProps, ...props };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardTimePicker {...props} />
        </MuiPickersUtilsProvider>
    );
}

const defaultProps = {
    fullWidth: true,
    variant: 'inline',
    autoOk: true,
    margin: 'normal'
}

export default TimePicker;
